// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-overlay{position:fixed;left:0;top:0;z-index:100;width:100%;height:100%}.video-overlay .video-bg{background-color:#000;opacity:.5;width:100%;height:100%}.video-player-holder{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.video-player-holder svg{position:absolute;right:0;top:-25px;width:15px;height:15px;fill:#333;cursor:pointer}.video-player-holder svg:hover{fill:#fff}.video-js .vjs-big-play-button{display:none!important}", ""]);
// Exports
module.exports = exports;
